
export default function CTA() {
  return (
    <section id="contacto" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto text-center">
        <div className="mb-12 rounded-3xl overflow-hidden">
          <img 
            src="https://public.readdy.ai/ai/img_res/efd0d9805878b920908fa10f85ab2f79.jpg"
            alt="Proyecto de calidad"
            className="w-full h-96 object-cover"
          />
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2 leading-tight">
          Transforma tu espacio
        </h2>
        <p className="text-4xl md:text-5xl font-light italic text-gray-400 mb-2">
          con profesionales
        </p>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12">
          de confianza
        </h2>

        <a 
          href="tel:628752701"
          className="inline-flex items-center justify-center px-12 py-4 bg-black text-white text-lg font-medium rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          Contactar Ahora
        </a>
      </div>
    </section>
  );
}
